import gql from 'graphql-tag';

const Query = {
  signatures: gql`
    {
      signatures {
        id
        sourceFilename
        sourceUrl
        signUrl
      }
    }
  `,

  signature: gql`
    query signature($id: Int!) {
      signature(id: $id) {
        id
        sourceFilename
        sourceUrl
        signUrl
      }
    }
  `,

  isSigned: gql`
    query isSigned($uuid: String!) {
      isSigned(uuid: $uuid)
    }
  `,

  sepasByContact: gql`
    query sepasByContact($contactId: Int!) {
      sepasByContact(contactId: $contactId) {
        id
        uuid
        signUuid
        signUrl
        signDate
        sepaDetail {
          id
          uuid
          bic
          iban
        }
        type
        status
        package {
          title
        }
        createdAt
      }
    }
  `,

  signaturesByContact: gql`
    query signaturesByContact($contactId: Int!, $type: String!) {
      signaturesByContact(contactId: $contactId, type: $type) {
        id
        uuid
        signUuid
        signUrl
        signDate
        sepaDetail {
          id
          uuid
          bic
          iban
        }
        type
        status
        package {
          title
        }
        createdAt
      }
    }
  `,

  validSignaturesByContact: gql`
    query validSignaturesByContact($contactId: Int!) {
      validSignaturesByContact(contactId: $contactId) {
        id
        uuid
        signUuid
        signUrl
        signDate
        sepaDetail {
          id
          uuid
          bic
          iban
        }
        type
        formulaType
        status
        package {
          title
        }
        createdAt
      }
    }
  `,

  transactionInfo: gql`
    query transactionInfo($signUuid: String!) {
      transactionInfo(signUuid: $signUuid) {
        status
        signerInfos {
          status
          actionDate
        }
      }
    }
  `,

  recoveryCandidateDocument: gql`
    query recoveryCandidateDocument($signUuid: String!, $contactInfoId: Int!, $category: String!) {
      recoveryCandidateDocument(signUuid: $signUuid, contactInfoId: $contactInfoId, category: $category) {
        id
        public_url
        category
        filename
      }
    }
  `,

  recoverySignedDocuments: gql`
    query recoverySignedDocuments($signatureId: Int!, $category: String) {
      recoverySignedDocuments(signatureId: $signatureId, category: $category) {
        id
        public_url
        category
        filename
      }
    }
  `,

  stats: gql`
    query stats($companyId: Int!) {
      stats(companyId: $companyId) {
        hits {
          id
          uuid
          signUuid
          signUrl
          signDate
          sepaDetail {
            id
            uuid
            bic
            iban
          }
          type
          status
          spouseName
          spouseValidate
          isOnIBoost
          hasChangedPackage
          formulaType
          createdAt
          package {
            name
          }
          user {
            id
            contact {
              id
              email
              isStaff
              isAgent
              contactsInfos {
                id
                name
                firstname
                phone
                street_number
                address
                city
                zipcode
                contractsPeriods {
                  dateEnd
                  package {
                    name
                  }
                }
                sources {
                  externalId
                }
              }
            }
          }
        }
        nbHits
      }
    }
  `,
  formulaStats: gql`
    query formulaStats($companyId: Int!, $type: String!) {
      formulaStats(companyId: $companyId, type: $type) {
        hits {
          id
          uuid
          signUuid
          signUrl
          signDate
          sepaDetail {
            id
            uuid
            bic
            iban
          }
          type
          status
          formulaType
          spouseName
          spouseValidate
          isOnIBoost
          hasChangedPackage
          createdAt
          package {
            name
          }
          user {
            id
            contact {
              id
              email
              isStaff
              isAgent
              contactsInfos {
                id
                name
                firstname
                phone
                contractsPeriods {
                  dateEnd
                  package {
                    name
                  }
                }
              }
            }
          }
        }
        nbHits
      }
    }
  `,
  packageStats: gql`
    query packageStats($companyId: Int!) {
      packageStats(companyId: $companyId) {
        packageName
        total
        signed
        percent
      }
    }
  `,
  contractLessStats: gql`
    query contractLessStats($companyId: Int!) {
      contractLessStats(companyId: $companyId) {
        id
        name
        firstname
        zipcode
        contact {
          email
        }
        sources {
          externalId
        }
        phone
      }
    }
  `,
  currentPackages: gql`
    query currentPackages($companyId: Int!, $userId: Int!) {
      currentPackages(companyId: $companyId, userId: $userId) {
        id
        company {
          code
        }
        name
        description
        title
        text
      }
    }
  `,
  synthesePackages: gql`
    query synthesePackages($companyId: Int!) {
      synthesePackages(companyId: $companyId) {
        id
        company {
          code
        }
        name
        description
        title
        text
      }
    }
  `,
  isMulti: gql`
    query isMulti {
      isMulti
    }
  `,
};

const Mutation = {
  requestContractSignature: gql`
    mutation requestContractSignature($params: requestContractSignatureInput) {
      requestContractSignature(params: $params) {
        id
        url
      }
    }
  `,

  requestSepaSignature: gql`
    mutation requestSepaSignature($params: requestSepaSignatureInput) {
      requestSepaSignature(params: $params) {
        id
        url
      }
    }
  `,

  deleteSignature: gql`
    mutation deleteSignature($id: Int!) {
      deleteSignature(id: $id)
    }
  `,

  deleteSepaSignature: gql`
    mutation deleteSepaSignature($id: Int!, $category: String!, $isCandidate: Boolean) {
      deleteSepaSignature(id: $id, category: $category, isCandidate: $isCandidate)
    }
  `,

  updateSignature: gql`
    mutation updateSignature($signatureId: Int!, $params: Signatureinput) {
      updateSignature(signatureId: $signatureId, params: $params)
    }
  `,

  updateDateAndStatus: gql`
    mutation updateDateAndStatus($signatureId: Int!, $params: SignatureDateStatusinput) {
      updateDateAndStatus(signatureId: $signatureId, params: $params)
    }
  `,

  signAddendumPackage: gql`
    mutation signAddendumPackage($params: SignAddendumPackageInput!) {
      signAddendumPackage(params: $params) {
        url
      }
    }
  `,

  signMLMAvenants: gql`
    mutation signMLMAvenants($contactId: Int!) {
      signMLMAvenants(contactId: $contactId) {
        url
      }
    }
  `,

  signAddendumFormula: gql`
    mutation signAddendumFormula($demand: changeFormulaType!) {
      signAddendumFormula(demand: $demand) {
        url
      }
    }
  `,

  signFormula: gql`
    mutation signFormula($demand: changeFormulaType!) {
      signFormula(demand: $demand) {
        url
      }
    }
  `,

  transactionInfoUpdateSignature: gql`
    mutation transactionInfoUpdateSignature($signUuid: String!) {
      transactionInfoUpdateSignature(signUuid: $signUuid) {
        status
        signerInfos {
          status
          actionDate
        }
      }
    }
  `,
};

export default {
  Query,
  Mutation,
};
